import Tools from '@/components/ezuro/workschedule/components/Tools.vue';
import Content from '@/components/ezuro/workschedule/components/Content.vue';

export default {
  name: 'WorkSchedule',
  props: {
    section: {
      type: String
    }
  },
  components: {
    Tools,
    Content
  },
  data () {
    return {
      filterData: null,
      isLoading: false,
      scheduleData: {},
      monthStats: null,
      view: 'table',
      workScheduleType: null
    }
  },
  computed: {
    title () {
      return (this.section ? this.$t('menu.work-schedule.' + this.section) : '');
    }
  },
  methods: {
    setView: function (value) {
      this.view = value;
    },
    filter: function (data) {
      if (data) {
        this.workScheduleType = data.type;
        this.filterData = this.BasicHelper.cloneObject(data);
      }

      this.filterRequest();
    },
    filterRequest: function (data) {
      const path = 'ezuro/schedule/row/' + this.section;

      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, this.filterData, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.scheduleData = response.data;
          this.monthStats = response.data.month_statistics;
        }
        this.isLoading = false;
      });
    },
    setLoading: function (value) {
      this.isLoading = value;
    }
  },
  watch: {
    section: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue != oldValue && oldValue !== undefined) {
          this.filter();
        }
      }
    }
  }
}
